import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

import { defaultSizes } from './constants';

export const SkeletonWrapper = styled.div`
    height: ${defaultSizes.cardHeight};
    width: ${defaultSizes.cardWidth};
`;

export const ImageSkeleton = styled(Skeleton)`
    height: 80%;
    border-radius: 8px;
`;

export const TitleSkeleton = styled(Skeleton)`
    margin-top: 0.5rem;
    height: 2.4rem;
    width: 100%;
`;

export const DateSkeleton = styled(Skeleton)`
    height: 2.4rem;
    width: 50%;
`;

function LibraryItemSkeleton({ className, imageHeight }: { className?: string; imageHeight?: number }) {
    return (
        <SkeletonWrapper className={className}>
            <ImageSkeleton variant="rectangular" height={imageHeight} />
            <TitleSkeleton />
            <DateSkeleton />
        </SkeletonWrapper>
    );
}

export default LibraryItemSkeleton;
